<!-- WELCOME LOGO VIDEO -->

<div class="welcome-screen" *ngIf="showWelcome">

    <!-- <video
        autoplay
        muted
        playsinline
        >

        <source src="assets/img/km-logo-intro.mp4"
                type="video/mp4">

    </video> -->

    <!-- <div class="video-container">

        <div class="gold-glow"></div>

       <video #introVideo muted autoplay playsinline preload="auto" (ended)="hideWelcome()">

            <source src="assets/img/cheflogo.mp4" type="video/mp4">

        </video>
    </div> -->

    <div class="video-container" *ngIf="showWelcome" (click)="hideWelcome()" style="cursor: pointer;">

        <div class="gold-glow"></div>

        <video #introVideo autoplay muted playsinline preload="auto" (ended)="hideWelcome()">

            <source src="assets/img/cheflogo.mp4" type="video/mp4">

        </video>

    </div>

    <h1>Welcome to Kitchen Magic</h1>

    <p>Where Every Dish is Crafted with Passion</p>
    
    <!-- <p style="font-size: 14px; opacity: 0.8; margin-top: 10px;">Click anywhere to continue</p> -->

</div>


<div class="homepage" [class.show]="!showWelcome">

    <app-navbar-style-two></app-navbar-style-two>



    <app-hometwo-banner></app-hometwo-banner>


    <app-category-list></app-category-list>


    <app-popular-products></app-popular-products>

    <!-- About Section -->
    <!-- <section class="km-about-section">
    <div class="container">
        <div class="about-grid">
            <div class="about-image">
                <img src="assets/img/about-food.jpg" alt="Kitchen Magic Food" />
                <div class="about-badge">
                    <span>🍽️</span>
                    <span>Since 2020</span>
                </div>
            </div>
            <div class="about-content">
                <span class="about-label">About Kitchen Magic</span>
                <h2 class="about-title">Bringing Delicious Food to Your Doorstep</h2>
                <p class="about-desc">
                    Kitchen Magic is your trusted mobile food truck serving authentic, delicious meals made with love and the finest ingredients. We bring the restaurant experience directly to you, whether it's at your neighborhood, office, or special event.
                </p>
                <div class="about-features">
                    <div class="feature-item">
                        <div class="feature-icon">
                            <i class='bx bxs-badge-check'></i>
                        </div>
                        <div class="feature-text">
                            <h4>Fresh Ingredients</h4>
                            <p>We source locally and use only the freshest ingredients daily</p>
                        </div>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon">
                            <i class='bx bxs-star'></i>
                        </div>
                        <div class="feature-text">
                            <h4>Expert Chefs</h4>
                            <p>Our experienced chefs craft every dish with passion and expertise</p>
                        </div>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon">
                            <i class='bx bxs-heart'></i>
                        </div>
                        <div class="feature-text">
                            <h4>Made with Love</h4>
                            <p>Every meal is prepared with care and attention to detail</p>
                        </div>
                    </div>
                </div>
                <a routerLink="/about" class="about-btn">Learn More About Us</a>
            </div>
        </div>
    </div>
</section> -->

    <!-- Promotional Banner Section -->
    <section class="promo-banner-section">
        <div class="promo-banner" routerLink="/product-menu">
            <div class="banner-bg" [style.background-image]="'url(assets/img/offer-banner1.png)'">
            </div>

        </div>
    </section>


    <!-- Testimonials Section -->
    <app-testimonials></app-testimonials>


    <!-- Why Choose Us Section -->
    <section class="km-why-section">
        <div class="container">
            <!-- Header Section -->
            <div class="why-header">
                <span class="why-label">🧑‍🍳 WHY CHOOSE US</span>
                <h2 class="why-main-title">What Makes Us <span class="special-text">Special</span></h2>
                <p class="why-subtitle">We don't just deliver food, we deliver experience, trust and happiness.</p>
            </div>

            <!-- Features Grid -->
            <div class="why-features-grid">
                <div class="feature-card">
                    <div class="feature-icon-wrap">
                        <i class='bx bxs-truck'></i>
                    </div>
                    <h3 class="feature-title">Mobile Food Truck</h3>
                    <p class="feature-desc">We bring delicious food directly to your neighborhood and events.</p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon-wrap">
                        <i class='bx bxs-shield-alt-2'></i>
                    </div>
                    <h3 class="feature-title">Quality Guaranteed</h3>
                    <p class="feature-desc">We use only the finest ingredients and maintain strict quality standards.
                    </p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon-wrap">
                        <i class='bx bx-time-five'></i>
                    </div>
                    <h3 class="feature-title">Quick Service</h3>
                    <p class="feature-desc">Hot, fresh food prepared on-site and served fast at our truck.</p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon-wrap">
                        <i class='bx bx-dollar-circle'></i>
                    </div>
                    <h3 class="feature-title">Best Prices</h3>
                    <p class="feature-desc">Affordable pricing without compromising on taste or quality.</p>
                </div>
            </div>

            <!-- Story Section -->
            <div class="story-section">
                <div class="story-content">
                    <span class="story-label">— SINCE DAY ONE</span>
                    <h2 class="story-title">The story, passion & magic behind every dish</h2>
                    <div class="story-stats">
                        <div class="stat-item">
                            <i class='bx bxs-group'></i>
                            <h3>100%</h3>
                            <p>Family Owned</p>
                        </div>
                        <div class="stat-item">
                            <i class='bx bxs-bowl-hot'></i>
                            <h3>15+</h3>
                            <p>Signature Dishes</p>
                        </div>
                        <div class="stat-item">
                            <i class='bx bxs-smile'></i>
                            <h3>1000+</h3>
                            <p>Happy Customers</p>
                        </div>
                    </div>
                </div>
                <div class="story-text">
                    <p>Kitchen Magic was born from family, tradition, and the unforgettable memories created around
                        food. Founded by <strong>Nagarajan Murugan</strong>, who was born and raised in Kanyakumari
                        district, Tamil Nadu, Kitchen Magic is inspired by the warmth of village-style cooking and the
                        love shared through homemade meals.</p>
                    <p>Growing up in a humble lower middle-class family, Nagarajan's passion for cooking came from
                        watching his father, <strong>Mr.Murugan</strong>, cook special weekend meals while his mother,
                        <strong>Mrs.Kala</strong>, added her own magical finishing touch with freshly ground spices and
                        secret seasonings.</p>
                    <div class="founder-signature">
                        <p class="signature-name">Nagarajan Murugan</p>
                        <p class="signature-title">Founder, Kitchen Magic</p>
                    </div>
                </div>
                <div class="story-image">
                    <img src="assets/img/fav-dish.png" alt="Signature Biryani Dish">
                </div>
            </div>
        </div>
    </section>




    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />



    <div class="floating-buttons">

        <!-- WhatsApp -->
        <a href="https://api.whatsapp.com/message/LUR4OM6PXSRVG1?autoload=1&app_absent=0"
           class="floating-btn whatsapp-btn"
           target="_blank"
           rel="noopener noreferrer"
           aria-label="WhatsApp">
            <i class="fab fa-whatsapp fa-lg"></i>
        </a>
    
        <!-- Call -->
        <a href="tel:+1 (669) 871-0461"
           class="floating-btn mobile-btn"
           aria-label="Call Us">
            <i class="fas fa-phone fa-lg"></i>
        </a>
    
        <!-- Instagram -->
        <a href="https://www.instagram.com/kitchenmagic013?utm_source=qr"
           class="floating-btn instagram-btn"
           target="_blank"
           rel="noopener noreferrer"
           aria-label="Instagram">
            <i class="fab fa-instagram fa-lg"></i>
        </a>
    
        <!-- Facebook -->
        <a href="https://www.facebook.com/people/Kitchen-Magic/61591900527242/?mibextid=wwXIfr"
           class="floating-btn facebook-btn"
           target="_blank"
           rel="noopener noreferrer"
           aria-label="Facebook">
            <i class="fab fa-facebook-f fa-lg"></i>
        </a>
    
    </div>




    <!-- Existing Home Page -->

</div>
